import { Settings, X } from "lucide-react";
import { usePlayground } from "../../contexts/PlaygroundContext";
import { Card, CardContent } from "../ui/card";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

const sliderClass =
    "h-2 w-full cursor-pointer appearance-none rounded-full bg-muted accent-primary disabled:cursor-not-allowed disabled:opacity-50 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-primary [&::-webkit-slider-thumb]:shadow-sm [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-primary";

export default function PlaygroundParametersPanel() {
    const { state, setParameters, toggleParametersPanel } = usePlayground();
    const { parameters } = state;

    return (
        <TooltipProvider>
            <Card>
                <CardContent className="flex flex-col gap-5 p-4">
                    <div className="flex items-center justify-between border-b border-border pb-3">
                        <div className="flex items-center gap-2 text-[14px] font-semibold text-foreground">
                            <Settings className="h-4 w-4" />
                            Parâmetros
                        </div>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <button
                                    type="button"
                                    onClick={toggleParametersPanel}
                                    aria-label="Fechar painel"
                                    className="flex h-7 w-7 items-center justify-center rounded text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                                >
                                    <X className="h-3.5 w-3.5" />
                                </button>
                            </TooltipTrigger>
                            <TooltipContent>Fechar painel</TooltipContent>
                        </Tooltip>
                    </div>

                    <div className="flex flex-col gap-2">
                        <div className="flex items-center justify-between">
                            <span className="text-[13px] font-semibold text-foreground">Max Tokens</span>
                            <span className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-[12px] text-foreground">
                                {parameters.maxTokens}
                            </span>
                        </div>
                        <input
                            type="range"
                            min={1}
                            max={8192}
                            step={1}
                            value={parameters.maxTokens}
                            onChange={(e) => setParameters({ maxTokens: Number(e.target.value) })}
                            disabled={state.isGenerating}
                            className={sliderClass}
                        />
                        <span className="text-[11px] text-muted-foreground">Número máximo de tokens na resposta</span>
                    </div>

                    <div className="flex flex-col gap-2">
                        <div className="flex items-center justify-between">
                            <span className="text-[13px] font-semibold text-foreground">Temperatura</span>
                            <span className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-[12px] text-foreground">
                                {parameters.temperature.toFixed(2)}
                            </span>
                        </div>
                        <input
                            type="range"
                            min={0}
                            max={2}
                            step={0.01}
                            value={parameters.temperature}
                            onChange={(e) => setParameters({ temperature: Number(e.target.value) })}
                            disabled={state.isGenerating}
                            className={sliderClass}
                        />
                        <span className="text-[11px] text-muted-foreground">Controla aleatoriedade (0 = determinístico, 2 = criativo)</span>
                    </div>

                    <div className="flex flex-col gap-2">
                        <div className="flex items-center justify-between">
                            <span className="text-[13px] font-semibold text-foreground">Top P</span>
                            <span className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-[12px] text-foreground">
                                {parameters.topP.toFixed(2)}
                            </span>
                        </div>
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step={0.01}
                            value={parameters.topP}
                            onChange={(e) => setParameters({ topP: Number(e.target.value) })}
                            disabled={state.isGenerating}
                            className={sliderClass}
                        />
                    </div>
                </CardContent>
            </Card>
        </TooltipProvider>
    );
}
